export default __webpack_public_path__ + "static/media/customers.97ae5338.svg";